import flatpickr from "flatpickr";
import AjaxUtils from './ajax-utils';
import * as $ from 'jquery';
import autocomplete from 'jquery-ui/ui/widgets/autocomplete'; //eslint-disable-line no-unused-vars

window.initializeInputs = () => {
    document.querySelectorAll('.text-input').forEach(container => {
        const input = container.querySelector('input') ?? container.querySelector('textarea');
        const select = container.querySelector('select');
        const label = container.querySelector('label');
        const contractorLogin = container.querySelector('.contractor');

        if(input) {
            if(input.classList.contains('date')) {
                flatpickr(input, {
                    disableMobile: true
                });

                input.addEventListener('change', e => {
                    input.setAttribute('value', e.target.value);
                });
            }

            input.addEventListener('input', (e) => {
                toggleEyebrow(e.target.value);
            });

            toggleEyebrow(input.value);
        }
        if(select) {
            select.classList.add('medium-gray');

            if(select.parentNode.classList.contains('select-wrapper')) {
                select.addEventListener('change', (e) => {
                    if(e.target.value.length === 0) {
                        select.classList.add('medium-gray');
                        select.classList.remove('black');
                    } else {
                        select.classList.remove('medium-gray');
                        select.classList.add('black');
                    }
                    toggleEyebrow(e.target.value);
                });
            } else {
                const wrapper = document.createElement('div');
                wrapper.classList.add('select-wrapper');

                const clone = select.cloneNode(true);
                clone.addEventListener('change', (e) => {
                    if(e.target.value.length === 0) {
                        clone.classList.add('medium-gray');
                        clone.classList.remove('black');
                    } else {
                        clone.classList.remove('medium-gray');
                        clone.classList.add('black');
                    }
                    toggleEyebrow(e.target.value);
                });

                wrapper.appendChild(clone);
                container.replaceChild(wrapper, select);
            }
        }

        function toggleEyebrow(value) {
            if(value.length > 0) {
                if(label) {
                    label.style.opacity = 1;
                }
            } else if (contractorLogin) {
                if(label) {
                    label.style.opacity = 1;
                }
            } else {
                if(label) {
                    label.style.opacity = 0;
                }
            }
        }
    });

    /**
     * Initialize all contractor autocomplete inputs
     * To use, add the attribute "data-autocomplete-contractors" to the input
     * Optionally (but recommended) add the attributes data-latitude and data-longitude
     * with the user's current location. This will speed up the autocomplete.
     */
    document.querySelectorAll('input[data-autocomplete-contractors]').forEach(input => {
        const latitude = input.getAttribute('data-latitude');
        const longitude = input.getAttribute('data-longitude');

        $(input).autocomplete({
            source: (request, response) => {
                AjaxUtils.getContractorAutocomplete(request.term, (err, result) => {
                    if(err || !result.success) {
                        response([]);
                    } else {
                        response(result.data);
                    }
                }, latitude, longitude);
            },
            focus: () => {
                return false;
            },
            select: (event, ui) => {
                input.value = ui.item.label;
                input.setAttribute('data-contractor-id', ui.item.value);
                return false;
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', window.initializeInputs);